export interface ISocialAuthOtcSentResponse {
  next: "otc_sent";
  linking_token: string;
  email: string;
}

export function isSocialAuthOtcSentResponse(
  value: unknown,
): value is ISocialAuthOtcSentResponse {
  return (
    typeof value === "object"
    && value !== null
    && (value as ISocialAuthOtcSentResponse).next === "otc_sent"
    && typeof (value as ISocialAuthOtcSentResponse).linking_token === "string"
    && typeof (value as ISocialAuthOtcSentResponse).email === "string"
  );
}
